import React from 'react'
import Dropdown from '../dropdown/Dropdown'
import FooterTopDropdownLinksItem from './FooterTopDropdownLinksItem'

const FooterTopDropdownLinks = ({ block, blockTitle }) => {
    const [openDropdown, setOpenDropdown] = React.useState(false)

    const title = React.useMemo(() => {
        const blockLabelToTextMap = {
            ['VoirAussi']: 'Voir aussi',
            ['QuestionReponse']: 'Questions ? Réponses !',
            ['ServiceEnLigne']: 'Services en ligne et formulaires',
            ['Reference']: 'Textes de loi et références',
        }

        return blockLabelToTextMap[block?.block] || ''
    }, [block])

    return (
        <Dropdown
            title={title}
            className="baseocom-footer-top-dropdown-links"
            isOpen={openDropdown}
            defaultOpen={block?.block === 'QuestionReponse' ? true : false}
            onClickOpen={() => setOpenDropdown(!openDropdown)}
            variable={
                block?.block === 'ServiceEnLigne'
                    ? `footer-service-en-ligne-dropdown-height`
                    : `footer-${block.ID}-dropdown-height`
            }
        >
            <div className="baseocom-content-in-dropdown">
                {block?.childrens?.map((child, index) => (
                    <FooterTopDropdownLinksItem key={index} block={child} blockType={block.block} />
                ))}
            </div>
        </Dropdown>
    )
}

export default FooterTopDropdownLinks
